import requests from './httpService';

const BankDetailsService = {
  getAllBankDetails() {
    return requests.get(`/bankdetails/list`);
  },
  getBankDetails(body) {
    return requests.post('/bankdetails/get', body);
  },
  createBankDetails(body) {
    return requests.post('/bankdetails/add', body);
  },
  getBankDetailsById(id) {
    return requests.get(`/bankdetails/${id}`);
  },
  deleteBankDetails(body) {
    return requests.delete(`/bankdetails/${body._id}`);
  },
  updateBankDetails(body) {
    return requests.put(`/bankdetails/${body._id}`, body);
  },
  addAllBankDetails(body) {
    return requests.post('/bankdetails/all', body);
  },
};

export default BankDetailsService;

